module.exports = __webpack_public_path__ + "img/login.03ad69a3.svg";